export default __webpack_public_path__ + "static/media/ec.05aed8c1.jpg";